import { HTTP_METHODS } from "../httpMethods";
import { Constants, FILE_UPLOAD_TEMPLATE_TYPE } from "../commonConstants";

const getType = (templateType) => {
  
  switch (templateType) {
    case Constants.BulkRewards:
      return FILE_UPLOAD_TEMPLATE_TYPE.REWARD_CATALOG;
    case Constants.BulkDigitalCodes:
      return FILE_UPLOAD_TEMPLATE_TYPE.DIGITAL_CODES;
    default:
      return FILE_UPLOAD_TEMPLATE_TYPE.SALES_TARGET;
  }
};

export const SAS_TOKEN_CONFIG={
    GET_SAS_TOKEN: (fileName, templateType) => ({
      // Need to add the format of templateType once API is available
      endPoint: `template/upload-url?fileName=${fileName}&templateType=${getType(templateType)}`,
      method: HTTP_METHODS.GET
    }),
}